export default{
    //Apiserveraddress:"https://elearning.waheguruitsol.co.in/",
    Apiserveraddress:"https://speech.learnisl.com/api/",
    Videoserveraddress:"https://learnisl.com/apidata/quiz",
    Imgerveraddress:"https://learnisl.com/apidata/wisl/",
}
